import { MAIN_LAYOUT_PX } from '../../assets/constants/index.tsx';
import type { Theme } from '@mui/material';

export const stackSx = (theme: Theme) => ({
  position: 'absolute',
  top: 712,
  right: 300,
  borderRadius: '50%',
  width: 480,
  height: 480,
  margin: '0 auto',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.warm_black,
  background: theme.palette.juicy_orange_grad,
  boxShadow: `0 4px 32px 0 ${theme.palette.accent}`,
  border: `2px solid ${theme.palette.glass_yellow_border_grad}`,
});
export const wrapperSx = (theme: Theme) => ({
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  px: MAIN_LAYOUT_PX,
  pt: 20,
  pb: 14,
  background: theme.palette.bg,
});